import React from 'react'
import { Modal } from 'react-bootstrap';
import Table from 'react-bootstrap/Table'
import { MdCancel } from 'react-icons/md'
import Moment from 'moment';


export default function AuditLogDetailPopup({ setShowAuditLogPopup, showAuditLogPopup, gridList, selectedrrnno }) {

    Date.prototype.addHours = function(h) {
        this.setTime(this.getTime() + (h*60*60*1000));
        return this;
      }
    
    return (
        <>
            <Modal show={showAuditLogPopup} size="md" centered className="auditmodel" onHide={() => setShowAuditLogPopup(false)}>
                <Modal.Header className="reasonmodalheader">
                    <Modal.Title>
                        <div className="flexbox">
                            <div> 
                                <p className="logdetail">Log Details</p>
                                <p className="lowh4" style={{ color: 'black' }}>RRN Number - <span style={{ color: '#131523' }}>{selectedrrnno}</span></p>
                            </div>
                            <div style={{ textAlign: 'right' }}><MdCancel style={{ fontSize: 25, color: '#7c7c7c', cursor: 'pointer' }} onClick={() => setShowAuditLogPopup(false)} /></div>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="reasonmodelbody">
                <div className="responsive-audit-table">
                        <Table variant="light" className="customTable autidtable">
                            <thead>
                                <tr className="pointer auditrow">
                                    <th>Column Name</th>
                                    <th>From</th>
                                    <th>To</th>
                                    <th>Date Time</th>
                                   
                                </tr>
                            </thead>
                            <tbody>
                                {gridList.length > 0 ?
                                    gridList.map((e, index) => {
                                        return (
                                            <tr>
                                                <td>{e.colmname || '--'}</td>
                                                <td> {(e.colmname === 'plaza_date_mark' || e.colmname === 'bank_date_mark' || e.colmname === 'expired_dt') && e.from != null ? Moment.utc( new Date(e.from).addHours(5.5)).format("DD.MM.yyyy, hh:mm A") : e.from || '--' }</td>
                                                <td>{(e.colmname === 'plaza_date_mark' || e.colmname === 'bank_date_mark' || e.colmname === 'expired_dt') && e.to != null  ? Moment.utc( new Date(e.to)).format("DD.MM.yyyy, hh:mm A") : e.to || '--' }</td>
                                                <td>{Moment.utc(new Date(e.datetime).addHours(5.5)).format("DD.MM.yyyy, hh:mm A")}</td>
                                                
                                            </tr>
                                        )
                                    })
                                    :
                                    <tr>
                                        <td colSpan="13" style={{ textAlign: 'center', backgroundColor: '#e4e4e4' }}>Data Not Found!</td>
                                    </tr>
                                }

                            </tbody>
                        </Table>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
